import { useTranslations } from '@vocab/react';
import { Box, Heading, TextLink } from 'braid-design-system';
import type { FC, MouseEvent } from 'react';

import { Error400Image } from 'src/App/ActionsPage/ErrorScreen/Error400Image';
import { downloadFile } from 'src/libs/fileDownload';

import { noop } from '../components/type';

import translations from './.vocab';

import { documentViewerContainer } from './documentViewerStyles.css';

interface Props {
  downloadUrl: string;
  onDownloadOriginal: () => void;
}
const FileErrorMessage: FC<Props> = ({
  downloadUrl,
  onDownloadOriginal = noop,
}) => {
  const onDownloadFile = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (!event.detail || event.detail === 1) {
      // Prevents the second click on the button
      downloadFile(downloadUrl, onDownloadOriginal);
    }
  };
  const { t } = useTranslations(translations);

  return (
    <Box
      className={documentViewerContainer}
      padding="xxlarge"
      background="surface"
      textAlign="center"
    >
      <Box paddingTop="medium" paddingBottom="medium">
        <Error400Image />
      </Box>
      <Heading level="4">
        {t('Something went wrong displaying this file.')}
        <br />
        {t('Click here to download it', {
          TextLink: (children) => (
            <TextLink href={downloadUrl} onClick={onDownloadFile}>
              {children}
            </TextLink>
          ),
        })}
      </Heading>
    </Box>
  );
};

export default FileErrorMessage;
